import React, { useContext } from "react"
import { ExportHierarchyContext } from "./Exports"
import * as Yup from "yup"
import { IExportAssuranceRequestModel } from "./models"
import { Form, Formik, FormikHelpers } from "formik"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import { IHttpErrorResponseModel } from "@common-models/*"
import { CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR } from "@common-constants/*"
import { getExportAssurance } from "./requests"
import FileAndDriveHelper from "@common-helpers/FileAndDriveHelper"

const ExportAssurance = () => {
     const context = useContext(ExportHierarchyContext)

     const schema = Yup.object().shape({})

     const initialValues: IExportAssuranceRequestModel = {}

     function handleSubmit(values: IExportAssuranceRequestModel, helpers: FormikHelpers<IExportAssuranceRequestModel>) {
          helpers.setStatus(null)

          toast.info("Génération en cours ...", {
               autoClose: false,
          })

          getExportAssurance(values)
               .then(r => {
                    const fileName = `export_assurance.csv`
                    FileAndDriveHelper.downloadFile(r.data, fileName)

                    toast.dismiss()
                    toast.success("L'export a bien été généré")
               })
               .catch(async (e: AxiosError) => {
                    let error: IHttpErrorResponseModel | undefined

                    // Check if we got a blob (file-like response)
                    if (e.response?.data instanceof Blob) {
                         try {
                              const text = await e.response.data.text()
                              error = JSON.parse(text)
                         } catch {
                              // fallback in case JSON parsing fails
                              error = { detail: "Une erreur inconnue est survenue." } as IHttpErrorResponseModel
                         }
                    } else {
                         error = e.response?.data
                    }

                    console.log("Parsed error:", error)

                    // Set form errors if validation
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set global status & toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail ?? "Erreur lors de l’export", { autoClose: false })

                    helpers.setSubmitting(false)
               })
               .finally(() => helpers.setSubmitting(false))
     }

     return (
          <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema}>
               {helpers => {
                    return (
                         <Form noValidate autoComplete="off">
                              {helpers.status && (
                                   <MyAlert type={"danger"} classNames={"mb-4"}>
                                        {helpers.status}
                                   </MyAlert>
                              )}

                              <div className="separator bg-primary my-5" />

                              {/* Submit button */}
                              <div className={"d-flex justify-content-end"}>
                                   <button
                                        className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                        type={"button"}
                                        disabled={helpers.isSubmitting}
                                        onClick={() => context.setSelectedType(null)}
                                   >
                                        <span className={"d-none d-lg-block"}>Annuler</span>
                                   </button>
                                   <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                        {!helpers.isSubmitting ? (
                                             <>
                                                  Télécharger <span className={"fas fa-download fs-4 ms-2"} />
                                             </>
                                        ) : (
                                             <MySimpleSpinner size={"sm"} />
                                        )}
                                   </button>
                              </div>
                         </Form>
                    )
               }}
          </Formik>
     )
}

export default ExportAssurance
